export default __webpack_public_path__ + "static/media/team79.b21c3698.JPG";